<template>
<div class="chapter">
<div class="inner_page">
      ﻿






<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>The Angel
Answer Book</title>
<p class="ser1" id="aa_3"><img alt="images/img-5-1.jpg" src="images/img-5-1.jpg"/></p>
<p class="ct" id="pANEL">
<a href="#/contents#bb_3"><span style="color:#007467;">What are angels?</span></a> </p>
<p class="tx1" id="pACk3">
<span class="dcap" style="color:#007467;">A</span>ngels are intelligent beings created by God as part of His spiritual realm. The
word
<i>angel</i>
means <i>messenger</i>, and they were created to serve and glorify their Creator. The Bible
refers to them as “ministering spirits,” “heavenly hosts,” and “holy ones” (Hebrews
1:14; Psalm 103:21; Jude 1:14). </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?6ed86d0b